import { createContext, FunctionComponent, PropsWithChildren, useContext } from 'react';

type AccountContext = {
  isSignedIn: boolean;
};
export const AccountContext = createContext<AccountContext | undefined>(undefined);

export const useAccountContext = (): AccountContext => {
  const context = useContext(AccountContext);
  if (context === undefined) {
    throw new Error('useAccountContext must be used within a AccountContext.Provider');
  }
  return context;
};

export const AccountContextProvider: FunctionComponent<PropsWithChildren<AccountContext>> = ({
  children,
  isSignedIn,
}) => {
  return <AccountContext.Provider value={{ isSignedIn }}>{children}</AccountContext.Provider>;
};
